import { connect } from 'react-redux';

import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import ApprovalsPage from './ApprovalsPageComponent';
import { getApprovals } from './actions/ApprovalsActions';
import coreActions from '../core/actions';

const allActions = { getApprovals, ...coreActions };

const mapStateToProps = (state) => ({
  config: state.config,
  approvals: state.approvals,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ApprovalsPage);
